export default "__VITE_ASSET__BNdXYZ0v__"